import { render, staticRenderFns } from "./EditingDFFile_URL2.vue?vue&type=template&id=16fc502d&"
import script from "./EditingDFFile_URL2.vue?vue&type=script&lang=js&"
export * from "./EditingDFFile_URL2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports